export Sale from "./sale.entity";
export Customer from "./customer.entity";
export Sellable from "./sellable.entity";
export StockOperation from "./stock_operation.entity";
export User from "./user.entity";
export OptionalGroup from "./optional-group.entity";
export Payment from "./payment.entity";
export Category from "./category.entity";
export CashRegister from "./cash_register.entity";
export InvoicesBilling from "./invoices-billing.entity";
export Discount from "./discount.entity";
export Variation from "./variation.entity";



// WEBPACK FOOTER //
// ./src/core/entity/index.js